import axios from "axios";
import tokenManager from "@/commons/utils/token";
import environment from "@/commons/utils/environment";
import { notifyError } from "@/commons/utils/toaster";
import { filterPilihProdiAPI } from "@/commons/utils/filterPilihProdiAPI";

const getKurikulumDataList = (params = {}) => {
 const { getToken } = tokenManager();
 const token = getToken();
 let paramsGet = Object.assign(params, {token});

 const apiUrl = filterPilihProdiAPI("/call/kurikulum", {
  apiWithFilter:"filter?by=programStudi&programStudiId={programStudiId}",
  defaultAPI: "list",
   });

 return axios.get(apiUrl, {
  params: paramsGet,  
  headers: {
   'Authorization': token,
  }
 }).catch((error) => {
  console.error(error);
  notifyError(error);
 })
} 

export default getKurikulumDataList